import React from 'react';
// material ui
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import withStyles from '@mui/styles/withStyles';
import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import theme from '../../config/theme'

const styles = theme => ({
    cancelBtn:{
        cursor:'pointer',
        backgroundColor:'gray',
        color:'#fff',
        fontWeight:'bold',
        fontSize:'16px',
        width:'40%',
        minWidth:'40%',
        maxWidth:'40%',
        borderRadius:'5px',
        textTransform:'capitalize',
        textAlign: 'center',
        height: '40px',
        lineHeight: 2.5,
        marginTop: '10px',
    },

    saveBtn:{
        cursor:'pointer',
        backgroundColor:'#0F467A',
        color:'#fff',
        fontWeight:'bold',
        fontSize:'16px',
        width:'40%',
        minWidth:'40%',
        maxWidth:'40%',
        borderRadius:'5px',
        textTransform:'capitalize',
        textAlign: 'center',
        height: '40px',
        lineHeight: 2.5,
        marginTop: '10px',
    },

    actionDialog:{
        width:'320px',
        minWidth:'320px',
        maxWidth:'320px',
        justifyContent:'space-between',
        alignSelf:'center',
        [theme.breakpoints.between('xs','md')]:{
            width:'240px',
            minWidth:'240px',
            maxWidth:'240px',
        },
    }
})

class DeleteDialog extends React.Component {
    _isMounted = false;

    handleClose = () => {
        this.props.onClose();
    }
    
    render() {
        let { classes, tReady, dispatch, handleSubmit,title,t,isRTL, ...other } = this.props;
        const ar = "'Cairo', sans-serif";
        const en = "'Poppins', sans-serif";
        const fontFamily = isRTL === 'ar' ? ar : en;
    return (
        (<React.Fragment>
            <Dialog
              {...other}
              onClose={this.handleClose}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
              style={{fontFamily:"'Poppins', sans-serif"}}
              fullWidth={true}
              dir={isRTL === 'ar' ? 'rtl' : 'ltr'}
              maxWidth='sm'
            >
            <StyledEngineProvider injectFirst>
                <ThemeProvider theme={theme}>
                        <DialogTitle id="alert-dialog-title" style={{fontFamily,fontWeight:'bold !important'}}>{title ? title : t('booking.dialog.delKid')}</DialogTitle>
                </ThemeProvider>
            </StyledEngineProvider>
            <DialogContent style={{fontFamily}}>
                {t('booking.dialog.delKid-title')}
            </DialogContent>
                <DialogActions classes={{root: classes.actionDialog}}>
                    <div className={classes.cancelBtn} onClick={this.handleClose} style={{fontFamily}}>{t('upgrade-dialog.can')}</div>
                    <div className={classes.saveBtn} onClick={handleSubmit} style={{fontFamily}}>{t('duplicate.delete')}</div>
                </DialogActions>
            </Dialog>
        </React.Fragment>)
    );}
}

export default withStyles(styles)(DeleteDialog);